import { render, staticRenderFns } from "./Special.vue?vue&type=template&id=2b60532a&scoped=true&"
import script from "./Special.vue?vue&type=script&lang=js&"
export * from "./Special.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60532a",
  null
  
)

export default component.exports